<template>
  <div class="dwp-space-y-8" v-loading="loading">
    <div class="dwp-flex dwp-justify-between dwp-items-center">
      <ArrowLeftIcon
        @click="$emit('update:value', false)"
        class="dwp-text-gray-500 dwp-w-6 dwp-h-6 dwp-cursor-pointer"
      />
      <div
        class="sm:dwp-text-2xl dwp-text-xl dwp-leading-none dwp-text-gray-700 dwp-font-medium"
      >Library</div>
      <div class="dwp-w-6 dwp-h-6"></div>
    </div>
    <div class="dwp-grid dwp-gap-4 dwp-grid-cols-2 sm:dwp-grid-cols-3">
      <SelectBox
        data-cy="library-item"
        v-for="item in items"
        :key="item.id"
        button-text="Import"
        @selected="load(item)"
        :class="item.status == 'draft' ? 'dwp-border-dashed dwp-border-red-300' : ''"
      >
        <div class="dwp-flex dwp-items-center dwp-justify-between dwp-w-full">
          <div
            v-if="item.tasks.length"
            @click="load(item)"
            class="dwp-cursor-pointer dwp-inline-flex dwp-items-center dwp-px-2 dwp-py-1 dwp-rounded-full dwp-text-xs dwp-font-medium dwp-leading-4 dwp-bg-gray-200 dwp-text-gray-800 group-hover:dwp-text-primary-700 group-hover:dwp-bg-primary-100 dwp-transition-colors dwp-duration-200"
          >{{ item.tasks.length }} Tasks</div>

          <div class="dwp-w-8 dwp-h-8">
            <a :href="item.partner_link" target="_blank">
              <StorageImage
                v-if="item.partner_logo"
                :path="item.partner_logo"
                class="dwp-max-w-full dwp-rounded-full"
              />
            </a>
          </div>
        </div>
        <h3
          @click="load(item)"
          class="dwp-cursor-pointer dwp-leading-none dwp-font-bold group-hover:dwp-text-primary-700 dwp-text-gray-700 dwp-transition-colors dwp-duration-200"
        >{{ item.title }}</h3>

        <a
          class="dwp-text-sm dwp-text-primary"
          v-if="item.partner_name && item.partner_link"
          :href="item.partner_link"
          target="_blank"
        >{{ item.partner_name }}</a>

        <div
          @click="load(item)"
          class="dwp-cursor-pointer dwp-text-sm dwp-text-gray-500"
          v-html="item.description"
        ></div>
      </SelectBox>
      <div
        v-if="Object.keys(items).length"
        class="dwp-group dwp-select-none dwp-bg-gray-100 dwp-rounded-md"
      >
        <div
          class="dwp-p-4 sm:dwp-p-6 dwp-space-y-4 dwp-text-center dwp-h-full dwp-flex dwp-flex-col dwp-items-center dwp-justify-center"
        >
          <ZapIcon class="dwp-text-gray-400 dwp-pb-2 dwp-h-8" />
          <h3
            class="dwp-leading-none dwp-font-bold group-hover:dwp-text-primary-700 dwp-text-gray-700 dwp-transition-colors dwp-duration-200"
          >More Coming Soon!</h3>
          <p class="dwp-text-sm dwp-text-gray-500">Please check back as we add more lists</p>
        </div>
      </div>
    </div>
    <div v-if="hasMore" class="dwp-flex dwp-items-center dwp-justify-center">
      <VButton type="outline" @click.native="fetch">Load More</VButton>
    </div>
  </div>
</template>

<script>
import SelectBox from "@/components/templates/SelectBoxTemplate.vue";
import VButton from "@/components/ui/VButton.vue";
import StorageImage from "@/components/ui/Image.vue";
import { get, sync } from "vuex-pathify";
import { ZapIcon, ArrowLeftIcon } from "vue-feather-icons";
import currentList from "@/mixins/current-list";

export default {
  mixins: [currentList],

  props: {
    value: String | Boolean,
  },

  data() {
    return {
      loading: false,
      hasMore: false,
    };
  },

  components: {
    SelectBox,
    ZapIcon,
    StorageImage,
    ArrowLeftIcon,
    VButton,
  },

  computed: {
    items: get("list-library/items"),
    lists: get("lists/items"),
    open: sync("ui/modal@list.import.open"),
    menu: sync("ui/menu@open"),
    user: get("user/user@data"),
  },

  async mounted() {
    this.$store.dispatch("user/logEvent", {
      name: "official_library_opened",
    });

    this.loading = true;
    await this.fetch();
    this.loading = false;
  },
  methods: {
    async fetch() {
      let result;
      try {
        let where;
        if (this?.user?.claims?.admin) {
          where = [["status", "in", ["published", "draft"]]];
        } else {
          where = [["status", "in", ["published"]]];
        }
        result = await this.$store.dispatch("list-library/fetchAndAdd", {
          clauses: {
            limit: 20,
            where,
          },
        });
      } catch (e) {
        alert("Something went wrong, please try again.");
      }
      this.hasMore = typeof result?.done !== "undefined" && !result?.done;
    },

    async load(list) {
      this.loading = true;
      let id;

      try {
        id = await this.$store.dispatch("lists/cloneToTeam", {
          list,
          moduleName: "task-library",
        });
      } catch (e) {
        console.error(e);
        alert("Something went wrong, please try again.");
      }

      this.$nextTick(() => {
        this.currentListId = id;
      });
      this.open = false;
      this.menu = false;
      this.loading = false;

      this.$store.dispatch("user/logEvent", {
        name: "official_library_downloaded",
        id: list.id,
      });
    },
  },
};
</script>